<template>
    <div id="w_users">
        <div class="row">
            <div class="col-lg-10 content-title pl-lg-3 mt-1 mb-3">
                <h2 class="content-title">Felhasználók</h2>
            </div>
            <div class="col-lg-2 text-right" v-if="user.is_administrator">
                <a v-on:click.prevent="newUser" class="c-pointer" title="Új felhasználó létrehozása">
                    <i class="far fa-plus-square font-icon"></i>
                </a>
            </div>
        </div>
        <user-filters ref="filters"></user-filters>
        <Users></Users>
    </div>
</template>

<script>
    import Users from '../../components/crm/Users'
    import UserFilters from "../../components/crm/UserFilters"
    import { mapGetters } from 'vuex'

    export default{
        name: 'w_users',
        components: {
            Users,
            UserFilters
        },
        computed: {
            ...mapGetters([
                'user',
            ])
        },
        methods: {
            newUser() {
                this.$router.push({
                    path: '/users/add',
                })
            }
        }
    }
</script>
